import { GroupBase, StylesConfig } from "react-select";
import colours from "styles/colours";
import shadows from "styles/shadows";

export const searchBarStyles = <
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>(
  overrides: Partial<StylesConfig<Option, IsMulti, Group>> = {}
): StylesConfig<Option, IsMulti, Group> => {
  const baseStyles: StylesConfig<Option, IsMulti, Group> = {
    option: (defaultStyles, state) => ({
      ...defaultStyles,
      backgroundColor:
        state.isSelected || state.isFocused
          ? colours.lightHighlightGrey
          : colours.white,
      paddingTop: 8,
      paddingBottom: 8,
      color: colours.elexonBlack,
      ":active": {
        backgroundColor: colours.lightHighlightGrey,
      },
    }),
    control: (base) => ({
      ...base,
      flexDirection: "row",
      borderRadius: 50,
      boxShadow: "none",
      alignItems: "center",
      minHeight: "3rem",
      height: "auto",
    }),
    placeholder: (base) => ({
      ...base,
      color: colours.darkGrey,
    }),
    valueContainer: (base) => ({
      ...base,
      paddingLeft: 16,
      alignItems: "center",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      paddingRight: 12,
    }),
    loadingIndicator: (base) => ({
      ...base,
      paddingRight: 12,
    }),
    dropdownIndicator: (base) => ({
      ...base,
      transform: "scaleX(-1)",
    }),
    menu: (base) => ({
      ...base,
      marginTop: 0,
      borderRadius: 8,
      overflow: "hidden",
      boxShadow: shadows.shadowMd,
    }),
    menuList: (base) => ({
      ...base,
      paddingTop: 8,
      paddingBottom: 8,
    }),
    singleValue: (base) => ({
      ...base,
      color: colours.darkGrey,
    }),
    input: (base) => ({
      ...base,
      color: colours.darkGrey,
    }),
  };

  return {
    ...baseStyles,
    ...overrides,
  };
};
